import { api } from './client';
import type { CreateRoleInput, Role } from '../features/roles/types';
export type { CreateRoleInput, Role } from '../features/roles/types';

export async function getRoles(): Promise<Role[]> {
  return api.get<Role[]>('/api/roles');
}

export async function createRole(data: CreateRoleInput): Promise<Role> {
  return api.post<Role>('/api/roles', data);
}

export async function updateRoleDisplayName(
  id: string,
  displayName: string
): Promise<Role> {
  return api.patch<Role>(`/api/roles/${id}`, { displayName });
}

